import React from "react";
import { default as MuiButton, ButtonProps } from "@mui/material/Button";
import { styled, useTheme } from "@mui/material/styles";
import { ButtonRoot } from "./ButtonRoot";
import { useGetCurrentBreakpoint } from "../../utilz/helpers/getCurrentBreakpoint";

interface LinkButtonProps extends ButtonProps {
  onClick: () => void;
  label: string;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  onClick,
  label,
  sx,
  ...rest
}) => {
  const theme = useTheme();
  const breakpoint = useGetCurrentBreakpoint(theme);
  let size = "large";

  if (breakpoint === "lg") {
    size = "large";
  } else if (breakpoint === "md") {
    size = "medium";
  } else {
    size = "small";
  }

  // Renderer
  return (
    <ButtonRoot
      variant={"text"}
      size={"large"}
      disableElevation
      disableFocusRipple
      disableRipple
      disableTouchRipple
      sx={{
        color: "#5563F5",
        backgroundColor: "transparent",
        borderColor: "transparent",
        outlineColor: "transparent",
        textDecoration: "underline",
        "&.Mui-focusVisible": {
          backgroundColor: "transparent",
          borderColor: "transparent",
          outlineColor: "transparent",
          color: "#5563F5",
        },
        "&:hover": {
          backgroundColor: "transparent",
          borderColor: "transparent",
          outlineColor: "transparent",
          color: "#5563F5",
        },
        "&:active": {
          backgroundColor: "transparent",
          borderColor: "transparent",
          outlineColor: "transparent",
          color: "#5563F5",
        },
        "&.Mui-disabled": {
          backgroundColor: "transparent",
          borderColor: "transparent",
          outlineColor: "transparent",
          color: "#5563F5",
        },
        ...sx,
      }}
      onClick={onClick}
      {...rest}
    >
      {label}
    </ButtonRoot>
  );
};
